import { Box, Typography } from '@mui/material';
import React from 'react';

const RedDotBlinking = ({ size, style, hideText = false, elapsed = null, fontSize = 10 }) => {
    const actualSize = size ?? 20;
    const center = actualSize / 2;
    return (
        <Box component="span" display="inline-flex" alignItems="center" gap={0.5} className="blinking">
            <svg height={actualSize} width={actualSize} style={style}>
                <circle cx={center} cy={center} r={center} fill="red" />
            </svg>
            {hideText ? null : (
                <Typography component="span" fontSize={fontSize}>
                    {elapsed ? elapsed : 'LIVE'}
                </Typography>
            )}
        </Box>
    );
};

export default RedDotBlinking;
